import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { AppleIcon, PlayStoreIcon } from '../components/StoreIcons';
import { SignupModal } from '../components/SignupModal';
import { PhoneFrame } from '../components/PhoneFrame';
import { Features } from '../components/Features';
import { AppIcon } from '../components/AppIcon';
import { Link } from 'react-router-dom';

export const Landing = () => {
  const [isSignupOpen, setIsSignupOpen] = useState(false);

  return (
    <div className="min-h-screen bg-black text-white overflow-hidden">
      {/* Hero Section with Video Background */}
      <div className="relative min-h-screen flex items-center">
        <div className="absolute inset-0 z-0">
          <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/70 to-black/80 z-10" />
          <video
            autoPlay
            loop
            muted
            playsInline
            className="w-full h-full object-cover scale-[1.02]"
            poster="https://i3.ytimg.com/vi/886596182/maxresdefault.jpg"
          >
            <source 
              src="https://cdn.pixabay.com/video/2023/11/19/189734-886596182_large.mp4" 
              type="video/mp4" 
            />
          </video>
        </div>

        <div className="max-w-6xl mx-auto px-4 z-20 py-20">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left Column - Copy */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="space-y-6"
            >
              <div className="flex items-center gap-4 mb-8">
                <AppIcon size="lg" />
                <h2 className="text-2xl font-bold">Rhythm</h2>
              </div>

              <h1 className="text-5xl md:text-6xl font-bold leading-tight">
                Find Your Perfect
                <span className="bg-gradient-to-r from-indigo-400 to-purple-500 bg-clip-text text-transparent">
                  {" "}Running Rhythm
                </span>
              </h1>
              
              <p className="text-xl text-gray-300">
                Experience the harmony of AI coaching, adaptive music, and real-time feedback. Let Rhythm guide your every step.
              </p>

              <div className="space-y-4">
                <div className="flex flex-wrap gap-4">
                  <button className="glass-button px-6 py-3 flex items-center gap-3">
                    <AppleIcon className="w-5 h-5" />
                    App Store
                  </button>
                  <button className="glass-button px-6 py-3 flex items-center gap-3">
                    <PlayStoreIcon className="w-5 h-5" />
                    Play Store
                  </button>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-4 items-start">
                  <button
                    onClick={() => setIsSignupOpen(true)}
                    className="text-sm text-gray-400 hover:text-white transition-colors"
                  >
                    Get notified when we launch →
                  </button>
                  <Link
                    to="/app"
                    className="lg:hidden glass-button px-6 py-3 text-sm font-medium"
                  >
                    Launch Demo App →
                  </Link>
                </div>
              </div>
            </motion.div>

            {/* Right Column - Phone Demo */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="relative mx-auto max-w-sm hidden lg:block"
            >
              <div className="absolute -inset-4 bg-gradient-to-br from-indigo-500/30 via-purple-500/30 to-pink-500/30 blur-2xl rounded-[3rem] z-0" />
              <div className="relative z-10">
                <PhoneFrame>
                  <iframe
                    src="/app"
                    className="w-full h-full"
                    title="Rhythm App Demo"
                  />
                </PhoneFrame>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <Features />

      {/* Footer */}
      <footer className="bg-black border-t border-white/10 py-8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-3">
              <AppIcon size="sm" animated={false} />
              <span className="font-medium">Rhythm</span>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/app"
                className="lg:hidden glass-button px-4 py-2 text-sm"
              >
                Open Demo
              </Link>
              <p className="text-sm text-gray-400">
                © 2024 Rhythm. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Signup Modal */}
      <SignupModal
        isOpen={isSignupOpen}
        onClose={() => setIsSignupOpen(false)}
      />
    </div>
  );
};